import React from "react";

const ModernCTA = () => {
  return (
    <section className="cta-modern">
      <div className="cta-modern-content">
        <div className="auto-container">
          <h2 className="cta-modern-title">
            ¿Listo para llevar tu empresa al siguiente nivel?
          </h2>
          <p className="cta-modern-description">
            Somos especialistas en Asesoría Tributaria, Laboral, Contable y
            Legal. Damos nuestros servicios a una amplia gama de empresas de
            diversos mercados y sectores económicos nacionales como
            internacionales.
          </p>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <a
              href="#nuestros_servicios"
              className="btn-modern btn-modern-secondary"
            >
              <i
                className="fas fa-info-circle"
                style={{ marginRight: "0.5rem" }}
              ></i>
              Conocer Servicios
            </a>
            <a
              href="https://wa.me/56961922323"
              className="btn-modern btn-modern-primary"
            >
              <i
                className="fab fa-whatsapp"
                style={{ marginRight: "0.5rem" }}
              ></i>
              Contactar Ahora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModernCTA;
